/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DistributionStatsFormat { 
    decimalSeparator?: DistributionStatsFormatDecimalSeparatorEnum;
    fieldSeparator?: DistributionStatsFormatFieldSeparatorEnum;
}
export enum DistributionStatsFormatDecimalSeparatorEnum {
    Comma = 'COMMA',
    Dot = 'DOT'
};
export enum DistributionStatsFormatFieldSeparatorEnum {
    Comma = 'COMMA',
    Semicolon = 'SEMICOLON',
    Tab = 'TAB',
    Pipe = 'PIPE'
};



